import { SwitchGroup } from '@mantine/core'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useState } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => {
	const [value, setValue] = useState<string[]>(
		Array.isArray(p.initialSelected)
			? p.initialSelected.map(String)	
			: typeof p.initialSelected === 'string'
				? [p.initialSelected]
				: []
	)

	useEffect(() => {
		const selectedItems =
			Array.isArray(value) && p.items
				? p.items.filter((item) =>
						value.includes(String(R.libs.just.get(item, p.valuePath)))
					)
				: []

		sendOutput(p.noodlNode, 'selectedValues', value)
		sendOutput(p.noodlNode, 'selectedItems', selectedItems)
		sendSignal(p.noodlNode, 'changed')
	}, [value, p.items])

	return (
		<SwitchGroup onChange={setValue} {...p} {...p.customProps}
			defaultValue={p.initialSelected || []}>
			{p.children}
		</SwitchGroup>
	)
})
